<div #intersect>
  @defer (on viewport(intersect)) {
    <!-- @if (isVisible()) { -->
    <ng-container [ngTemplateOutlet]="content.templateRef"></ng-container>
    <!-- } -->
  } @placeholder {}
</div>
